import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectCandlestickTilesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.CANDLESTICK_TILE];

export const selectCandlestickTileState = (state: State, widgetKey: string) =>
    selectCandlestickTilesState(state)[widgetKey];
